import { trigger, animate, style, group, query, transition } from '@angular/animations';

export const routerTransition = trigger('routerTransition', [
  transition(
    'welcome => sign-in',
    group([
      query(':enter, :leave', style({ position: 'fixed', width: '45%' }), { optional: true }),
      group([
        query(
          ':enter',
          [
            style({ transform: 'translateX(100%)' }),
            animate('0.3s ease-in-out', style({ transform: 'translateX(0%)' })),
          ],
          { optional: true },
        ),
        query(
          ':leave',
          [
            style({ transform: 'translateX(0%)' }),
            animate('0.3s ease-in-out', style({ transform: 'translateX(-100%)' })),
          ],
          { optional: true },
        ),
      ]),
    ]),
  ),
  transition('survey => welcome, sign-in => welcome', [
    query(':enter, :leave', style({ position: 'fixed', width: '45%' }), { optional: true }),
    group([
      query(
        ':enter',
        [
          style({ transform: 'translateX(-100%)' }),
          animate('0.3s ease-in-out', style({ transform: 'translateX(0%)' })),
        ],
        { optional: true },
      ),
      query(
        ':leave',
        [style({ transform: 'translateX(0%)' }), animate('0.3s ease-in-out', style({ transform: 'translateX(100%)' }))],
        { optional: true },
      ),
    ]),
  ]),
  transition('sign-in => survey, survey => sign-in', [
    query(':enter, :leave', style({ position: 'fixed', width: '45%' }), { optional: true }),
    group([
      query(':enter', [style({ opacity: '0' }), animate('0.3s ease-in-out', style({ opacity: '1' }))], {
        optional: true,
      }),
      query(':leave', [style({ opacity: '1' }), animate('0.3s ease-in-out', style({ opacity: '0' }))], {
        optional: true,
      }),
    ]),
  ]),
]);
